import { I18nService } from '../../i18n/I18nService';
import { I18N_KEYS } from '../../i18n/keys';
import { FocusTrap } from '../../accessibility/FocusTrap';
import { getDonateQrImagePath } from '../../constants/donateConfig';

export class DonateModal {
  private i18n: I18nService;
  private focusTrap: FocusTrap;
  private dialog: HTMLDialogElement | null = null;

  constructor(i18n: I18nService, focusTrap: FocusTrap) {
    this.i18n = i18n;
    this.focusTrap = focusTrap;
  }

  render(): void {
    this.dialog = document.getElementById('donate-modal') as HTMLDialogElement;
    if (!this.dialog) {
      this.dialog = document.createElement('dialog');
      this.dialog.id = 'donate-modal';
      this.dialog.className = 'modal modal--donate';
      document.body.appendChild(this.dialog);
    }
  }

  open(): void {
    if (!this.dialog) this.render();

    const currentLocale = this.i18n.getLocale();
    const qrImagePath = getDonateQrImagePath(currentLocale);

    this.dialog!.innerHTML = `
      <div class="modal__content">
        <div class="modal__header">
          <h2>${this.i18n.t(I18N_KEYS.DONATE_TITLE)}</h2>
          <button class="modal__close-btn" type="button" aria-label="Close">&times;</button>
        </div>
        <div class="modal__body donate__body">
          <p class="donate__message">${this.i18n.t(I18N_KEYS.DONATE_MESSAGE)}</p>
          <div class="donate__qr-container">
            <img
              class="donate__qr-image"
              src="${qrImagePath}"
              alt="${this.i18n.t(I18N_KEYS.DONATE_SCAN_QR)}"
            />
            <p class="donate__scan-text">${this.i18n.t(I18N_KEYS.DONATE_SCAN_QR)}</p>
          </div>
          <p class="donate__thank-you">${this.i18n.t(I18N_KEYS.DONATE_THANK_YOU)}</p>
        </div>
        <div class="modal__footer">
          <button class="donate__close-btn btn btn--primary" type="button">${this.i18n.t(I18N_KEYS.DONATE_CLOSE)}</button>
        </div>
      </div>
    `;

    this.dialog!.querySelector('.modal__close-btn')?.addEventListener('click', () => this.close());
    this.dialog!.querySelector('.donate__close-btn')?.addEventListener('click', () => this.close());

    this.dialog!.showModal();
    this.focusTrap.activate(this.dialog!);
  }

  close(): void {
    this.focusTrap.deactivate();
    if (this.dialog?.open) {
      this.dialog.close();
    }
  }

  isOpen(): boolean {
    return this.dialog?.open === true;
  }
}
